import React, { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { translationKeys } from "../../util/translationKeys"
import { ActionFailedTemplate } from "./ActionFailedTemplate"
import { useI18next } from "gatsby-plugin-react-i18next"
import { routes } from "../../routes"
import { trackDatadogAction } from "../../services/datadog-rum"

type Props = {
  errorMessage: string | undefined
  countryCode: string
  slug: string
  orderId: string
}

export const PaymentFailedScreen = ({
  errorMessage,
  countryCode,
  slug,
  orderId,
}: Props) => {
  const { t } = useTranslation()
  const { navigate } = useI18next()

  useEffect(() => {
    trackDatadogAction("payment_failed_screen_shown", { errorMessage, slug })
  }, [])

  const errorTitle = t(translationKeys.webPaymentFailed)
  const errorDescription =
    errorMessage || `${t(translationKeys.comboBuyVouchersFailedSubtext)}`

  return (
    <ActionFailedTemplate
      header={errorTitle}
      subtitle={errorDescription}
      buttonText={t(translationKeys.comboVerifyStatusIncorrectTryAgain)}
      buttonOnClick={() => {
        navigate(
          routes.checkout.base({
            orderId,
            countryCode,
            slug,
          })
        )
      }}
    />
  )
}
